import React from "react";
import "./../style/common.css"

const TermsAndConditions = () => {
  return (
    <div className="page-container">
      <h1>Terms & Conditions</h1>
      <p>
        Welcome to Mandurah Cafe! These Terms and Conditions govern your use of our website and services, including online food ordering, delivery, and takeaway.
      </p>

      <h2>1. Ordering</h2>
      <p>
        By placing an order through our website, you agree to provide accurate information. Orders are subject to availability and confirmation.
      </p>

      <h2>2. Delivery & Pickup</h2>
      <p>
        We offer both delivery and pickup options. Delivery times are estimates and may vary based on location and order volume. Pickup orders must be collected within the specified time window.
      </p>

      <h2>3. Payments</h2>
      <p>
        All payments must be made online via the payment methods provided. Prices are listed in Australian Dollars (AUD) and include applicable taxes.
      </p>

      <h2>4. Cancellation & Refund</h2>
      <p>
        Orders can only be cancelled within 5 minutes of placement. Refunds will not be issued once the order has been prepared. In the case of errors or issues, please contact us directly.
      </p>

      <h2>5. User Accounts</h2>
      <p>
        You are responsible for maintaining the confidentiality of your login credentials and agree not to share your account information with others.
      </p>

      <h2>6. Intellectual Property</h2>
      <p>
        All content, including images, logos, and text, on our website is owned by Mandurah Cafe and may not be reproduced without permission.
      </p>

      <h2>7. Changes to Terms</h2>
      <p>
        We may update these terms from time to time. Please review them regularly. Continued use of the site constitutes your acceptance of the updated terms.
      </p>

      <h2>8. Contact Us</h2>
      <p>
        If you have any questions regarding these terms, please contact us at <a href="mailto:support@mandurahcafe.com.au">support@mandurahcafe.com.au</a>.
      </p>
    </div>
  );
};

export default TermsAndConditions;
